export { default } from '@esentai/core/features/mallBonuses/api';
